<template lang="pug">
  div.container-fluid.animated.fadeIn
    nav(aria-label="breadcrumb")
      b-breadcrumb
        b-breadcrumb-item
          router-link(to="/rb")
            i.fas.fa-running
            span.ml-1 {{ $t("ui.running_ball") }}
        b-breadcrumb-item
          router-link(to="/rb/rtfcommentary")
            i.fas.fa-comment
            span.ml-1 {{ $t("ui.rtf_commentary") }}
    div.row.mb-5
      div.col-md-12
        div.card
          div.card-header
            div.row
              div.col-md-12.mb-1
                div.form-row
                  div.col-sm-9.col-md-6.mb-1
                    b-input-group(size="sm")
                      b-input-group-text(slot="prepend")
                        i.icon-magnifier
                      DebounceInput(required autofocus type="text" v-model="rtfSearch" :placeholder="$t('message.search_by_id_name_desc')")
                  div.col-sm-3.col-md-1.mb-1
                    b-form-radio-group(
                      buttons
                      v-model="filterBy"
                      size="sm"
                      button-variant="outline-info"
                    )
                      b-form-radio(value="id") {{ $t("ui.id") }}
                      b-form-radio(value="name") {{ $t("ui.name") }}
                      b-form-radio(value="desc") {{ $t("ui.description") }}
              div.col-md-12
                b-button(v-b-modal.addRTFComm type="button" variant="primary" size="sm").mr-1
                  i.fa.fa-plus
                  span {{ $t("ui.combine.add_rtf") }}
          div.card-body.p-1.clusterize
            .clusterize-scroll
              table.tablex(style="width: auto;" v-columns-resizable)
                thead
                  tr
                    th.text-center.sticky-position(width=60)
                      span {{ $t('ui.action') }}
                    th.text-center.sticky-position(width=60)
                      span {{ $t("ui.id") }}
                    th.sticky-position(width=240)
                      span {{ $t("ui.rtf_name") }}
                    th.sticky-position
                      span {{ $t("ui.description") }}
                tbody.clusterize-content
                  tr(v-for="(item, index) in filteredRTZCommList")
                    td.actions.text-center
                      span
                        a.fa.fa-edit.text-primary(href="#" @click="onEdit(item)" :title="$t('ui.edit')")
                      span
                        a.fa.fa-trash.text-danger(href="#" @click="onDelete(item)" :ttile="$t('ui.delete')")
                    td.text-center
                      span {{ item.RTFCommentaryID }}
                    td
                      span(:title="item.RTFCommentaryName") {{ item.RTFCommentaryName }}
                    td
                      span(:title="item.RTFCommentaryDescription") {{ item.RTFCommentaryDescription }}
      addRTFComm(@clicked="addRTFComm" @failed="handleFailed")
      editRTFComm(ref="editRTFComm" :rtfId="editSelectedId" :rtfName="editSelectedName" :rtfDesc="editSelectedDescription" @clicked="editRTFComm" @failed="handleFailed")
      deleteRTFComm(ref="deleteRTFComm" :rtfId="deleteSelectedId" :rtfName="deleteSelectedName" @clicked="deleteRTFComm" @failed="handleFailed")
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import DebounceInput from "@/library/DebounceInput";
import addRTFComm from "@/components/rtfCommentary/addRTFComm.vue";
import editRTFComm from "@/components/rtfCommentary/editRTFComm.vue";
import deleteRTFComm from "@/components/rtfCommentary/deleteRTFComm.vue";

export default {
  components: {
    DebounceInput,
    addRTFComm,
    editRTFComm,
    deleteRTFComm
  },
  data() {
    return {
      filterBy: "id",
      rtfList: [],
      rtfSearch: "",
      feedback: {
        success: false,
        status: errorTags.request.failed
      },
      editSelectedId: "",
      editSelectedName: "",
      editSelectedDescription: "",
      deleteSelectedId: "",
      deleteSelectedName: ""
    };
  },
  computed: {
    filteredRTZCommList() {
      return this.rtfList.filter(rtf => {
        if (this.filterBy === "name") {
          return rtf.RTFCommentaryName.toLowerCase().indexOf(this.rtfSearch.toLowerCase()) > -1;
        } else if (this.filterBy === "id") {
          return rtf.RTFCommentaryID.toString().indexOf(this.rtfSearch) > -1;
        } else if (this.filterBy === "desc" && rtf.RTFCommentaryDescription) return rtf.RTFCommentaryDescription.toLowerCase().search(this.rtfSearch) > -1;
      });
    }
  },
  mounted: function() {
    let url = config.getRtfCommUrl();

    var json = {
      action_by: this.$store.getters.username,
      session_token: this.$store.getters.sessionToken,
      page_id: config.accessRoles.rtfcommentary,
      RTFCommentaryID: -1
    };

    this.$http.post(url, json).then(
      function(response) {
        // Success
        try {
          if (response) {
            if (typeof response.data.status == "string") {
              this.feedback.success = response.data.status == "1";
            } else {
              this.feedback.success = response.data.status == 1;
            }
            this.feedback.status = response.data.statusdesc;
            if (this.feedback.success == true) {
              this.rtfList = response.data.tbl_rtfcommentary;
            } else {
              this.$helpers.handleFeedback(this.feedback.status);
            }
          }
        } catch (error) {
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showToast(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      },
      function(response) {
        // Error
        this.feedback.success = false;
        this.feedback.status = errorTags.request.failed;
        this.$helpers.showToast(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
      }
    );
  },
  methods: {
    getDate(dateTime) {
      let convertDateFormat = new this.$moment(dateTime).format("YYYY-MM-DD, HH:mm:ss A");
      return convertDateFormat;
    },
    onEdit(e) {
      this.editSelectedId = e.RTFCommentaryID;
      this.editSelectedName = e.RTFCommentaryName;
      this.editSelectedDescription = e.RTFCommentaryDescription;
      this.$refs.editRTFComm.$refs.editRTFComm.show();
    },
    onDelete(e) {
      this.deleteSelectedId = e.RTFCommentaryID;
      this.deleteSelectedName = e.RTFCommentaryName;
      this.$refs.deleteRTFComm.$refs.deleteRTFComm.show();
    },
    addRTFComm: function(rtfId, rtfName, rtfDesc) {
      let newrtf = {
        RTFCommentaryID: rtfId,
        RTFCommentaryName: rtfName,
        RTFCommentaryDescription: rtfDesc
      };

      this.rtfSearch = "";
      this.rtfList.unshift(newrtf);
      this.$helpers.showDialog(this.$t("ui.combine.add_rtf"), this.$t("message.success"), "success");
    },
    editRTFComm: function(rtfId, rtfName, rtfDesc) {
      this.rtfList.filter(function(rtf) {
        if (rtf.RTFCommentaryID === rtfId) {
          rtf.RTFCommentaryName = rtfName;
          rtf.RTFCommentaryDescription = rtfDesc;
        }
      });
      this.editSelectedId = "";
      this.editSelectedName = "";
      this.editSelectedDescription = "";
      this.$helpers.showDialog(this.$t("ui.combine.edit_rtf"), this.$t("message.success"), "success");
    },
    deleteRTFComm: function(rtfId) {
      let i = this.rtfList
        .map(rtf => {
          return rtf.RTFCommentaryID;
        })
        .indexOf(rtfId);
      this.rtfSearch = "";
      this.rtfList.splice(i, 1);
      this.$helpers.showDialog(this.$t("ui.combine.delete_rtf"), this.$t("message.success"), "success");
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
